import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ROUTES } from './nursesidebar-routes.config';
import { NurseRouteInfo } from "./nursesidebar.metadata";
import { Router, ActivatedRoute } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { AppData } from '../../../../models/appdata';

import { ActorImageController, PatientInfoByFormattedCodeController } from '../../../../models/actor/actor';
declare var misc: any;
import { AppFeaturesList } from '../../../../../../../src/app/ncs/constants/constants';
import { NgbAddNewPatient } from '../../provider/dashboard/modal/addnewpatient.modal';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbSearchPatientModal } from '../../follow up/counsellingregistry/modal/searchpatient.modal';
import { NgbPatientBillsModal } from '../../follow up/counsellingregistry/modal/patientbills.modal';
import { NgbAddbilladv } from '../../opbilling/modal/addbilladv.modal';
import { NgbAddNewEnquiry } from '../../provider/dashboard/modal/addnewenquiry.modal';
declare var $: any;

@Component({
  selector: 'nurseapp-sidebar',
  templateUrl: './nursesidebar.component.html',
})

export class NurseSidebarComponent implements OnInit {
  @Output() closeside: EventEmitter<any> = new EventEmitter();
  public menuItems: any[];
  public TestVersion: Boolean = false;
  public DispalyName: string;
  public ActorImage: string;
  public ActorCode: number = 0;
  public CanShowProfileImage: number = 0;
  public CanEditProfileImage: number = 0;
  public IsSetAccessRights: boolean;
  public IsAdmin: boolean = false;
  public RoleName: string;
  public NavActorImageFile: string;
  public BranchName: string;
  ValueChangeActorImageController: ActorImageController;

  selectedItem: number = 1;

  public openSections: { [key: string]: boolean } = {
    'registration': true,
    'followUp': true,
    'appointments': true,
    'billingPharmacy': false,
    'billing': true,
    'billVerifications': false,
    'lab': false,
    'inPatient': false,
    'ehr': false,
    'ivfHome': false,
    'ivf': true,
    'erp': false,
    'events': false,
    'finance': false,
    'refunds': false,
    'expense': false,
    'reports': false,
    'others': false
  };

  public isSectionOpen(key: string): boolean {
    return this.openSections[key] !== false;
  }

  public toggleSection(key: string): void {
    this.openSections[key] = !this.isSectionOpen(key);
  }

  public expandAll(): void {
    Object.keys(this.openSections).forEach(key => this.openSections[key] = true);
  }

  public collapseAll(): void {
    Object.keys(this.openSections).forEach(key => this.openSections[key] = false);
  }

  HasAccess(featureName: string): boolean {
    const appUserSettingInfo = AppData.Instance().AppUserSettingInfo;
    if (!appUserSettingInfo || !appUserSettingInfo.RoleFeatureLinkInfoController) {
      return true;
    }
    const roleName = AppData.Instance().SelectedRoleName;
    const f = appUserSettingInfo.RoleFeatureLinkInfoController.filter(function (v) {
      return v && v.FeatureName == featureName && roleName == v.RoleName;
    });
    return f != null && f.length > 0;
  }
  HasAccess2(featureName: string): boolean {
    return false;
  }
  SetIsAdmin() {
    switch (this.RoleName) {
      case 'Super Admin':
        this.IsAdmin = true;
        break;
      default:
        {
          this.IsAdmin = false;
        }
    }
  }
  constructor(private router: Router,
    private route: ActivatedRoute, public translate: TranslateService, private modalService: NgbModal, ) {

  }

  public logo: string = "";
  public logowidth: number;
  public logoheight: number;
  ngOnInit() {
    const cas = AppData.Instance().cas || {} as any;
    this.logo = cas.Navlogo || "Navlogo.png";
    this.logowidth = cas.HlogoWidth || 150;
    this.logoheight = cas.HlogoHeight || 50;
    if (AppData.Instance().UserLoginDetails != null) {
      this.DispalyName = AppData.Instance().UserLoginDetails.DisplayName || 'admin';
      this.RoleName = AppData.Instance().SelectedRoleName || 'Super Admin';
      this.SetIsAdmin();
      this.NavActorImageFile = AppData.Instance().UserLoginDetails.ActorImageFile;
      this.BranchName = AppData.Instance().SelectedBranchName;
      this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
      this.ValueChangeActorImageController = new ActorImageController();
      if (AppData.Instance().AppUserSettingInfo && AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController) {
        this.onSetFeatureAccessConfig();
      }
    }
  }
  onCloseClick() {
    this.closeside.emit();
  }
  Event() {
    this.onCloseClick();
  }
  listClick(event, newValue) {
    //console.log(newValue);
    this.selectedItem = newValue;  // don't forget to update the model here
    // ... do other stuff here ...
  }
  onactorImageInfoChange(event: any) {


    if (event != null) {

      this.ValueChangeActorImageController = event;

      if (this.ValueChangeActorImageController.ActorImageFileUrl != null) {
        //console.log('this.ValueChangeActorImageController.ActorImageFileUrl-->' + this.ValueChangeActorImageController.ActorImageFileUrl);

        this.ActorImage = this.ValueChangeActorImageController.ActorImageFileUrl;
        AppData.Instance().UserLoginDetails.ActorImageFile = this.ValueChangeActorImageController.ActorImageFileUrl;
      }


    }

  }

  //NGX Wizard - skip url change
  //ngxWizardFunction(path: string) {
  //  if (path.indexOf('forms/ngx') !== -1)
  //    this.router.navigate(['forms/ngx/wizard'], { skipLocationChange: false });
  //}
  OpenModal() {
    this.closeside.emit();
    const modalRef = this.modalService.open(NgbAddNewPatient,
      {
        centered: true,
        size: "lg",
        backdrop: 'static',
        keyboard: false
      })

  }
  OpenEnquiry() {
    this.closeside.emit();
    const modalRef = this.modalService.open(NgbAddNewEnquiry,
      {
        centered: true,
        size: "lg",
        backdrop: 'static',
        keyboard: false
      })

  }
  OpenBill() {
    this.closeside.emit();
    const modalRef = this.modalService.open(NgbSearchPatientModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.result.then((val: string) => {

      this.router.navigate(['healins/iohreceipt', { FormattedCodedata: val }]);

      // modalRef.componentInstance.FormattedCode = val;
      //modalRef.componentInstance.PatientName = val;
      //modalRef.componentInstance.PatientRegistrationNumber = val;
      //modalRef.result.then(x => { this.GetTreatmentCyclesController() })
    });
  }
  AddRefund() {
    this.closeside.emit();
    const modalRef = this.modalService.open(NgbSearchPatientModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.PATIENT_OBJ = true;
    modalRef.componentInstance.PATIENT_FORMATTED_CODE = false;
    modalRef.result.then((val: PatientInfoByFormattedCodeController) => {
      const modalRef = this.modalService.open(NgbPatientBillsModal,
        {
          centered: true,
          size: "lg",
          backdrop: 'static',
          keyboard: false
        })
      modalRef.componentInstance.ActorCode = val.ActorCode;
      modalRef.result.then((val2: number) => {
        this.router.navigate(['healins/refundreceipt', { FormattedCodedata: val.FormattedCode, ChargeEntryCode: val2 }]);
      });


    });
  }
  OpenBillAdv() {
    this.closeside.emit();
    const modalRef = this.modalService.open(NgbAddbilladv,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.Type = "FromMain"
  }
  onSetFeatureAccessConfig() {


    //Features


    var Feature_NurseProfile_ProfileImage = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_ProfileImage.toUpperCase())




    if (Feature_NurseProfile_ProfileImage.length > 0) {
      if (Feature_NurseProfile_ProfileImage[0].Edit === true) {
        this.CanEditProfileImage = 1;
      }
      if (Feature_NurseProfile_ProfileImage[0].List === true) {
        this.CanShowProfileImage = 1;
      }
    }


    this.IsSetAccessRights = true;





    //
  }
}
